import { CategoryResource as Res } from '@shared/resources/category';
import { CategoryCreateUpdateDto as DTO } from '@shared/dto/category';
import { CrudService } from './crud.service';

export class CategoryService extends CrudService<DTO, DTO, Res> {
  protected pathPrefix(): string {
    return 'categories';
  }
}
